export default __webpack_public_path__ + "static/media/cv.46937889.svg";